import React from 'react';
import PropTypes from 'prop-types';
import { ChevronRight } from 'lucide-react';
import RelationshipStrengthBadge from '../../../../atoms/RelationshipStrengthBadge';
import { ArrowHead, BadgeOnLine, CenterCol, Line } from '../../IntroPathCard.styles';

// The center column between two people: a connector line with the
// relationship-strength badge sitting on it and an arrowhead pointing forward.
export const Connector = ({ level }) => (
  <CenterCol>
    <Line />
    <BadgeOnLine>
      <RelationshipStrengthBadge level={level} />
    </BadgeOnLine>
    <ArrowHead aria-hidden="true">
      <ChevronRight size={14} strokeWidth={2} />
    </ArrowHead>
  </CenterCol>
);

Connector.propTypes = {
  level: PropTypes.string.isRequired,
};
